import { Theme } from '../../models/system/theme';

/**
 * Theme "Summit_Tire"
 * Reference to setting in table dbo.Theme.
 * Note: Summit theme, Color 1 should be Color 2 in definition in http://demostudiosji.dapasoft.com/skins/Skin%20(17).html?2420
 */
export const Theme_Summit_Tire: Theme = {
  name: 'Summit_Tire',
  properties: {
    /* own color */
    '--mainColor': '#D71821', // Color 2
    '--mainButtomColor': '#D71821', // main Buttom
    '--minorColor': '#0A0405', // Color 3
    '--mainColorB':'#D71821',
    '--subColor': '#343433', // Color 1.
    '--mainBackgroundColor': '#B3B2B3', // Background
    '--mainTitleColor':'#f2f4f9',
    '--minorBackgroundColor': '#FFFFFF', // NAV
    '--importantLabel': '#333',
    '--ordinary_label': '#666',
    '--nonImportantLabel': '#999',
    '--dashColor1': '#abb5c4',
    '--dashColor2': '#B3B2B3',
    '--controlColor_span1': '#1F2125',
    '--controlInptBackgroundColor1': '#f3f2f2',
    '--navTitleColor': '#FFFFFF',
    '--navTitleMinorColor': '#FFFFFF',
    
    '--extraPriceColor':'#287f3d',
    '--inTransitColor':'#0435c5',
    '--cartIconColor':'#FFFFFF',    
    '--grid_th_Color': '#F6F6F6',
    '--grid_td_Color': '#FFFFFF',

    /*hearder*/
    '--navbarBackground': '#FFFFFF',
    '--headerClickColor': '#D71821',
    '--headerClickColor_border': '#090e2126',

    /*order*/
    '--controlColor_order_buttom1': '#343433',
    '--controlColor_order_buttom2': '#343433',
    '--controlColor_order_buttom3': '#090E22',
    '--controlColor_order_buttom4': '#090e21',
    '--controlColor_buttomBorder1': '#D71821',

    /*cart*/
    '--grid_thColor': '#F6F6F6',
    '--controlColor_buttom2': '#090E22',
    '--controlColor_buttom3': '#C31C28',
    '--controlColor_buttom2_font': '#FFFFFF',
    '--dialogBackgroundColor': '#FFFFFF',

    '--noFillColor':'#86888c',
    '--disableCarat':"#ccc",

     /*Direct Container Order Grid */
     '--GridRightBorderTH': 'B3B2B3',
     '--GridRightBorderTD': '#CCC',
     '--GridHoverColorTR': '#F09BA2',
     '--TextOnHover': '#FFFFFF'

    /* Bootstrap css override */
  }
};
